import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutOfficeRecurringPayAdjustmentList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceOffRecurDeduct: DataSource;
    tableOfficeRecuringPayAdjustments: Table;
}
